
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#272727","d":"M0 0h512v114H0z"}}),_c('path',{attrs:{"fill":"#e40112","d":"M0 114h512v114H0z"}}),_c('path',{attrs:{"fill":"#07893f","d":"M0 228h512v114H0z"}}),_c('circle',{attrs:{"fill":"#e40112","cx":"256","cy":"125","r":"95"}})])
          )
        }
      }
    